
import React, { useEffect, useState } from 'react';
import "./NewService.css"
import Container from './Container/Container';
import { serviceEndpoint } from '../../../../variables/services';
// import Loading from '../../../../components/Project/Service/Loading/Loading';
import TaskRunning from '../../../../components/taskRunning/TaskRunning';
import StatusPage from '../../../../components/taskRunning/statusPage/StatusPage';
import { Back } from '../../../../components/back/Back';


const NewService = ({ exit, projectId }) => {
    const [serviceType, setServiceType] = useState("container");
    const [currentPage, setCurrentPage] = useState("chooseType");
    const [name, setName] = useState("");
    const [taskId, setTaskId] = useState(0);
    const [data, setData] = useState({})
    const [error, setError] = useState("");


    const submit = (data) =>{
        setCurrentPage("taskRunning")
        fetch(serviceEndpoint + "/service", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data),
                    })
                    .then(res => {
                    if (!res.ok) { 
                        return res.json().then(data => {
                        throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                        });
                    }
                    return res.json(); // Only parse JSON if response is OK (200)
                    })
                    .then(data => {
                        setTaskId(data["task_id"])
                    })
                    .catch(error => {
                    // setError(error.message); // Store error message in state
                    console.error("Error fetching user:", error);
                    });
                    
                
    }

    const checkName = () => {
        if (name.length < 2) {
            setError("Service name must be at leats 2 charecters long.");
            return false
        }
        return true
    }

    return (
        <div className='shadow-glow new-service'>
            {/* <h3>new service</h3> */}
            {currentPage === "chooseType" && 
            <div className='new-service-form first-page'>
                <h1>New Service</h1>
                <button className='exit' onClick={exit}>X</button>
                <div >
                    <div className='info-block'>
                        <label className="new-service-form-label">type:</label>
                        <select name="type" id="service-type" className='type-select' onChange={(e) => {setServiceType(e.target.value)}}>
                                <option value="container">Container</option>
                                <option value="serverles">Serverless</option>
                                <option value="server">Server</option>
                                <option value="external">External</option>
                        </select>
                    </div>
                    <div className='info-block'>
                        <label>name:</label>
                        <input value={name} onChange={(e)=>{setName(e.target.value)}}></input>
                    </div>
                </div>
                <label className='error'>{error}</label>
                <div className='buttons'>
                    <button className="next-button" onClick={()=>{if (checkName()) {setCurrentPage(serviceType)}}}>next</button>
                </div>
            </div>
        }   
        {currentPage === "container" && <Container data={data} setData={setData} projectId={projectId} submit={()=>submit(data)} serviceName={name} exitWindow={exit} back={()=>setCurrentPage("chooseType")}/>}
        {currentPage === "taskRunning" && <TaskRunning taskId={taskId} done={()=>{setCurrentPage("statusPage")}}/>}
        {currentPage === "statusPage" && <StatusPage taskId={taskId} exit={exit} successMessage="Service created Successfully!" failureMessage="Failed to create service"/>}
        </div>
    );
};

export default NewService;